import styled from "styled-components";
import { BASIC_LINE, BASIC_WHITE } from "../../../constants/colors";
import { Menu } from "../../../ducks/menu";
import { Button } from "../../atoms/Button";
import { MenuItem } from "./MenuItem";

type Props = {
  isShow: boolean;
  showAppCouponHeader: boolean;
  menus: Menu[];
  selectedLimitedMenus: Menu[];
  onFavorite: (menuId: number, menuCode: string, favorite: boolean) => void;
  onSelectMenu: (args: {
    menuId: number;
    menuName: string;
    amount: number;
    isEarlyBird: boolean;
    optionId?: number;
    optionName?: string;
  }) => void;
  onClose: () => void;
};

export const RecommendedMenuPopup: React.FC<Props> = ({
  isShow,
  showAppCouponHeader,
  menus,
  selectedLimitedMenus,
  onFavorite,
  onSelectMenu,
  onClose,
}) => {
  return (
    <RecommendedMenuPopupContainer $isShow={isShow}>
      <MenuPopupContainer>
        <Header $showAppCouponHeader={showAppCouponHeader}>
          <HeaderTitle>ご一緒にいかがですか</HeaderTitle>
        </Header>

        <MenuListContainer>
          {menus.map((menu) => (
            <MenuItemContainer key={menu.id}>
              <MenuItem
                menu={menu}
                selectedLimitedMenus={selectedLimitedMenus}
                onFavorite={(menuCode, favorite) =>
                  onFavorite(menu.id, menuCode, favorite)
                }
                onSelectMenu={(selectedMenu) =>
                  onSelectMenu({
                    menuId: menu.id,
                    menuName: menu.name,
                    isEarlyBird: menu.isEarlyBird,
                    amount: selectedMenu.amount,
                    optionId: selectedMenu.optionId,
                    optionName: selectedMenu.optionName,
                  })
                }
                noPopup
                disableClick
              />
            </MenuItemContainer>
          ))}
        </MenuListContainer>

        <ButtonWrapper>
          <Button
            btnStyle="secondary"
            onClick={onClose}
            text="他の商品を追加"
          />
        </ButtonWrapper>
      </MenuPopupContainer>
    </RecommendedMenuPopupContainer>
  );
};

const RecommendedMenuPopupContainer = styled.div<{ $isShow: boolean }>`
  position: fixed;
  top: 50px;
  left: 0;
  width: 100%;
  height: calc(100% - 50px);
  background-color: ${BASIC_WHITE};
  opacity: ${({ $isShow }) => ($isShow ? 1 : 0)};
  transform: ${({ $isShow }) =>
    $isShow ? "translate(0, 0)" : "translate(0, 100%)"};
  transition: all 0.5s cubic-bezier(0.13, 0.79, 0.36, 0.97);
  overflow: scroll;
  z-index: 1000;
`;

const MenuPopupContainer = styled.div`
  max-width: 980px;
  position: relative;
  margin: auto;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div<{ $showAppCouponHeader: boolean }>`
  display: flex;
  justify-content: center;
  padding: ${({ $showAppCouponHeader }) =>
    $showAppCouponHeader ? "32px 16px 16px" : "0 16px 16px"};
  margin: 45px 16px 27px;
  line-height: 1;
  border-bottom: 1px solid ${BASIC_LINE};
`;

const HeaderTitle = styled.p`
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  padding: 0;
`;

const MenuItemContainer = styled.div`
  margin: 0 16px;
`;

const MenuListContainer = styled.div`
  margin-bottom: 20px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 0 150px;
  button {
    height: auto;
    line-height: 1;
    font-weight: 600;
  }
`;
